import React, { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { useQueryCourseContent } from 'gql/queries/course';
import { useQueryMe } from 'gql/queries/me';
import {
  mutationEditorQuestionCreateFromIA,
  mutationEditorReset,
} from 'gql/mutations/editor';
import { useURLToStateQuestionCommentOpenQuestion } from 'hooks/useURLToState';
import Editor from './Editor';

const EditorContainer = (props) => {
  const { t } = useTranslation();
  const { isLoading: isLoadingMe, data: dataMe } = useQueryMe();
  const wantsAI = isLoadingMe ? false : dataMe.me.wantsAI;
  const { courseId } = useParams();
  const headerGetter = useCallback(() => {
    const header = document.getElementById('editor-header');
    if (header) {
      const headerPosition = header.getBoundingClientRect();
      if (
        headerPosition.top <= 0 &&
        !header.classList.contains('sticky-header')
      ) {
        header.classList.add('sticky-header');
      }
      if (
        headerPosition.top > 0 &&
        header.classList.contains('sticky-header')
      ) {
        header.classList.remove('sticky-header');
      }
    }
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', headerGetter);
    return () => window.removeEventListener('scroll', headerGetter);
  }, [headerGetter]);
  const { isLoading, data } = useQueryCourseContent({
    variables: {
      courseId,
    },
  });
  const isEmpty = useMemo(
    () =>
      isLoading
        ? false
        : data.course.questionsToApprove.length === 0 &&
          data.course.questions.length === 0 &&
          data.course.chapters.length === 0 &&
          data.course.files.length === 0,
    [data, isLoading],
  );
  const nQuestions = useMemo(
    () =>
      isLoading
        ? 0
        : data.course.questions.length +
          data.course.chapters.reduce(
            (p, chapter) => p + chapter.questions.length,
            0,
          ),
    [data, isLoading],
  );
  useURLToStateQuestionCommentOpenQuestion(isLoading, data);
  useEffect(() => {
    mutationEditorReset();
    return () => {
      mutationEditorReset();
    };
  }, []);
  return (
    <Editor
      course={data?.course}
      handleQuestionCreateFromIA={mutationEditorQuestionCreateFromIA}
      isEmpty={isEmpty}
      isLoading={isLoading}
      nQuestions={nQuestions}
      t={t}
      wantsAI={wantsAI}
      {...props}
    />
  );
};

export default EditorContainer;
